<template>
    <Admin
        :title="__('Slider', null, $page.props.profile_locale)"
    >
        <ImageUpload
            :images="slides"
            :route-links="{
                remove: 'remove.slide.image',
                change: 'upload.slider.images'
            }"
        />
        <div class="mt-5">
            <h1 class="font-bold text-sm">{{__('Links to images', null, $page.props.profile_locale)}}</h1>
            <ul class="mt-2">
                <li
                    class="space-y-3 border-t border-gray-300 flex items-center space-x-3"
                    v-for="(image, key) in links"
                    :key="image.id"
                >
                    <div>
                        <a target="_blank" :href="image.href" v-if="image.href"><img class="w-20 h-20" width="80" height="80" :src="image.link"></a>
                        <img v-else class="w-20 h-20" width="80" height="80" :src="image.link">
                    </div>
                    <InputLabel
                        type="url"
                        :id="'links.' + key + '.href'"
                        :placeholder="__('Enter link - https://example.com', null, $page.props.profile_locale)"
                        class="md:w-1/2"
                        v-model="image.href"
                        @change="updateLinks"
                    />
                    <InputLabel
                        type="url"
                        :id="'links.' + key + '.title'"
                        :placeholder="__('Title', null, $page.props.profile_locale)"
                        v-model="image.title"
                        @change="updateLinks"
                    />
                </li>
            </ul>
        </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import ImageUpload from 'UI/ImageUpload';
    import InputLabel from 'UI/InputLabel';
    import { Inertia } from '@inertiajs/inertia';
    import { ref } from '@vue/reactivity';
    import { watch } from '@vue/runtime-core';

    export default {
        props: {
            slides: Array
        },
        components: {
            Admin,
            ImageUpload,
            InputLabel
        },

        setup(props) {

            const links = ref(props.slides);
            const active = ref(null);
            const post = ref(false);

            watch(() => props.slides, (val, oldVal) => {
                if(!post.value) links.value = val;
            })

            function updateLinks(ev, image) {
                post.value = true;
                Inertia.post(route('upload.slider.images'), {
                    type: 'href',
                    links: links.value,
                }, {
                    preserveScroll: true,
                    onSuccess: () => {
                        post.value = false;
                    },
                })
            }
            return {
                updateLinks,
                links,
                active
            }
        }
    }
</script>
